import React from 'react'
import Banner from './Banner'
import SpecialOffer from '../ProductHomePageComponent/SpecialOffer'
import PartnerWithUsComponent from './PartnerWithUsComponent'
import WhyChooseWileyComponent from './WhyChooseWileyComponent'
import Carousel from './Carousel'
import Attribution from './Attribution'
import Cookies from 'js-cookie'

class Body extends React.Component{
    constructor(props){
        super(props)
        this.state = {}
    }
    componentDidMount(){
        this.props.homePageComponents && this.props.homePageComponents.forEach(homePageComponent => {
            this.setState({
                [homePageComponent.acf_fc_layout]: homePageComponent.content
            })
        })
    }
    render(){
        return(
            <div className="home-page">
                <div className="body-background">
                    {this.state.banner &&
                    <Banner bannerData={this.state.banner} blurBackground={this.props.blurBackground}/>
                    }
                    {Cookies.get('mena-country')!=="true" && this.state.special_offer &&
                        <SpecialOffer specialOfferData = {this.state.special_offer}/>
                    }
                    {this.state.partner_with_us &&
                    <PartnerWithUsComponent partnerData={this.state.partner_with_us} blurBackground={this.props.blurBackground}/>
                    }
                    {this.state.why_choose_wiley &&
                    <WhyChooseWileyComponent whyWileyData={this.state.why_choose_wiley}/>
                    }
                    {this.state.what_our_customers_say &&
                    <Carousel carouselData={this.state.what_our_customers_say}/>
                    }
                    {this.state.attribution &&
                    <Attribution attributionData={this.state.attribution}/>
                    }
                </div>
            </div>
        )
    }
}
export default Body